import React from 'react';
import { DashboardCardProps } from '../types';
import {
  CardContent,
  CardHeader,
  CardTitle,
  IconBox,
  StyledCard
} from './styled';

const DashboardCard = ({
  title,
  icon,
  iconBgColor,
  children = null
}: DashboardCardProps) => {
  return (
    <StyledCard elevation={0}>
      <CardHeader>
        <IconBox sx={{ backgroundColor: iconBgColor }}>{icon}</IconBox>
        <CardTitle variant='h6'>{title}</CardTitle>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </StyledCard>
  );
};

export default DashboardCard;
